module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-bar-vertical02 left_car_info",
    class: {
      'opac': _vm.isPlaying
    }
  }, [_c('dl', [_c('dt', [_c('span', [_vm._v("行车时长：" + _vm._s(_vm.carPassedTimeStr))]), _c('span', [_vm._v("平均时速：" + _vm._s(_vm.traceRecord.avgSpeed) + "km （畅通时：" + _vm._s(_vm.traceRecord.highestSpeed) + "km  拥堵时：" + _vm._s(_vm.traceRecord.lowestSpeed) + "km）")]), _c('span', [_vm._v("行驶里程：" + _vm._s(_vm.traceRecord.mileage) + "km")])]), _vm._v(" "), _c('dd', [_vm._v("\n\t\t\t当前地址：" + _vm._s(_vm.ads) + "\n\t\t")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d16fcf8","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/didivehicletrace/VehicleInfo.vue
// module id = 1559
// module chunks = 0